// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"112":"567bba26","212":"567bba26","364":"bfc36f95","449":"ff5bcea8","468":"ff5bcea8","764":"e66f7170","984":"ff5bcea8","996":"3ded5a25"}[chunkId] + ".chunk.css";
};